// extracted by mini-css-extract-plugin
module.exports = {"pearWidgetContainer":"PearCommerceProduct_pearWidgetContainer__iPRHZ","productLocatorWidgetContainer":"PearCommerceProduct_productLocatorWidgetContainer__n1IUf"};